import React from 'react';
interface CTAButtonProps {
  href: string;
  text: string;
  subtext?: string;
  className?: string;
}
export function CTAButton({
  href,
  text,
  subtext,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`block w-full max-w-xl mx-auto text-center bg-green-500 hover:bg-green-400 text-white rounded-lg py-4 px-6 shadow-[0_8px_0_rgb(21,128,61)] hover:shadow-[0_6px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all duration-200 ${className}`} data-id="element-87">
      <span className="block text-2xl md:text-3xl font-black uppercase tracking-wide text-shadow-sm" data-id="element-88">
        {text}
      </span>
      {subtext && <span className="block text-sm md:text-base font-medium mt-1 opacity-90" data-id="element-89">
          {subtext}
        </span>}
    </a>;
}